import { render, staticRenderFns } from "./kyc-reload-dialog.vue?vue&type=template&id=eb0cd464"
import script from "./kyc-reload-dialog.vue?vue&type=script&lang=js"
export * from "./kyc-reload-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports